export default "__VITE_ASSET__DEkobzey__"